"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BaseInvite () {
        return BaseInvite;
    },
    get default () {
        return _default;
    }
});
const _components = require("@react-email/components");
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _components1 = require("~/services/mail/templates/components");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const BaseInvite = ({ baseTitle, name, email, link })=>/*#__PURE__*/ _react.createElement(_components.Html, null, /*#__PURE__*/ _react.createElement(_components1.RootWrapper, null, /*#__PURE__*/ _react.createElement(_components.Head, null), /*#__PURE__*/ _react.createElement(_components.Preview, null, "You’ve been invited to a Base"), /*#__PURE__*/ _react.createElement(_components.Body, {
        className: "bg-white"
    }, /*#__PURE__*/ _react.createElement(_components1.ContentWrapper, null, /*#__PURE__*/ _react.createElement(_components.Heading, {
        className: "text-gray-900 text-center font-bold m-auto text-xl md:text-2xl"
    }, "You’ve been invited to a Base"), /*#__PURE__*/ _react.createElement(_components.Section, {
        className: "py-6 mx-auto font-bold mx-auto text-center text-gray-900 text-base"
    }, baseTitle), /*#__PURE__*/ _react.createElement(_components.Text, {
        className: "text-gray-600 text-center text-sm !mt-0 !mb-6"
    }, /*#__PURE__*/ _react.createElement("span", {
        className: "font-bold text-gray-800"
    }, name), " (", email, ") has invited you to collaborate on", ' ', /*#__PURE__*/ _react.createElement("span", {
        className: "font-bold text-gray-800"
    }, baseTitle), " base."), /*#__PURE__*/ _react.createElement(_components.Button, {
        className: "text-center w-full text-base font-bold bg-brand-500 text-white rounded-lg h-10",
        href: link
    }, /*#__PURE__*/ _react.createElement(_components.Text, {
        className: "!my-[8px]"
    }, "Accept Base Invite"))), /*#__PURE__*/ _react.createElement(_components1.Footer, null))));
BaseInvite.PreviewProps = {
    baseTitle: 'Base Title',
    name: 'John Doe',
    email: 'johndoe@nocodb.com',
    link: 'https://app.nocodb.com'
};
const _default = BaseInvite;
